import { Injectable } from '@angular/core';
import { QueryConfig } from '@hospitality-bot/admin/shared';
import { ApiService } from '@hospitality-bot/shared/utils';
import { Observable } from 'rxjs';
import { PettyCashListResponse } from '../types/petty-cash.types';

@Injectable({
  providedIn: 'root',
})
export class PettyCashService extends ApiService {
  getPettyCashList(
    config: QueryConfig,
    entityId: string
  ): Observable<PettyCashListResponse> {
    return this.get(`/api/v1/petty-cash${config.params}`, {
      headers: { 'entity-id': entityId },
    });
  }

  exportCSV(config: QueryConfig): Observable<Blob> {
    return this.get(`/api/v1/petty-cash${config.params}`, {
      responseType: 'blob',
    });
  }

  createPettyCash(data: any, entityId: string): Observable<any> {
    return this.post('/api/v1/petty-cash', data, {
      headers: { 'entity-id': entityId },
    });
  }
}
